export const convertToRawFormat = (formattedData: any) => {
  let blockIndex = 0;
  const blocks: any = [];

  Object.keys(formattedData).forEach(key => {
    const { blockStyle, text } = formattedData[key];
    let charIndex = 0;
    let currentOffset = 0;
    const inlineStyleRanges: any = [];

    let blockText = '';

    text.forEach(({ characters, ...styles }: { characters: string, [key: string]: any }) => {
      const newOffset = currentOffset + characters.length;

      Object.entries(styles).forEach(([style, value]: [string, any]) => {
        if (value) {
          const styleName = style === 'bold' ? 'BOLD' :
            style === 'italic' ? 'ITALIC' :
              style === 'underline' ? 'UNDERLINE' :
                `${value}`;
          inlineStyleRanges.push({
            offset: charIndex,
            length: characters.length,
            style: styleName
          });
        }
      });

      blockText += characters;
      charIndex += characters.length;
      currentOffset = newOffset;
    });

    blocks.push({
      key: `block-${blockIndex}`,
      text: blockText,
      type: blockStyle,
      depth: 0,
      inlineStyleRanges: inlineStyleRanges,
      entityRanges: [],
      data: {}
    });

    blockIndex++;
  });

  return {
    blocks: blocks,
    entityMap: {}
  };
};

